export const interestForm = {
  message: {
    type: 'input',
    label: 'Message (optional)',
    value: '',
    config: {
      placeholder: 'Type your message here',
      multiline: true,
      rows: 4,
    },
    errorMsg: 'Missing',
    valid: true,
    touched: true,
  },
};


export const requestForm = {
  options: {
    type: 'async_select_multiple',
    label: 'Request Options',
    value: '',
    config: {
      placeholder: 'Select request options',
      defaultOptions: true,
      help_text: 'You can select multiple options',
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
};



// WEBPACK FOOTER //
// ./src/activities/components/activityFormStates.js